import React, { ReactNode } from 'react';

import { Container } from '../../../../../../components/Container';
import { MobileTakeoverModal } from '../../../../../../components/MobileTakeoverModal';

type Props = {
  children: ReactNode,
}

export const StepContainer = ({
  children,
  ...rest
}: Props) => (
  <Container
    maxWidth={['100%', null, '848px']}
    py={3}
    width={1}
    {...rest}
  >
    <MobileTakeoverModal />
    {children}
  </Container>
);
